/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { EApiRequestStatus } from '../../models';
import { IUserState } from '../state';

const getUserState = createFeatureSelector<IUserState>('user');

export const getUsername = createSelector(
  getUserState,
  (state: IUserState): string => state.username
);

export const getPassword = createSelector(
  getUserState,
  (state: IUserState): string => state.password
);

export const getSessionToken = createSelector(
  getUserState,
  (state: IUserState): string => state.sessionToken
);

export const getVerificationAttempts = createSelector(
  getUserState,
  (state: IUserState): number => state.verificationAttempts
);

export const getResendAttempts = createSelector(
  getUserState,
  (state: IUserState): number => state.resendAttempts
);

export const getSetPasswordRequestStatus = createSelector(
  getUserState,
  (state: IUserState): EApiRequestStatus => state.setPasswordRequestStatus
);

export const getResendCodeRequestStatus = createSelector(
  getUserState,
  (state: IUserState): EApiRequestStatus => state.resendCodeRequestStatus
);

export const getVerifyAccountRequestStatus = createSelector(
  getUserState,
  (state: IUserState): EApiRequestStatus => state.verifyAccountRequestStatus
);
